import { render, staticRenderFns } from "./AdvanceFourSectionLayout.vue?vue&type=template&id=2a60d366&"
import script from "./AdvanceFourSectionLayout.vue?vue&type=script&lang=js&"
export * from "./AdvanceFourSectionLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdvanceFourSectionLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports